import { FC } from 'react';

import { Box } from '@mui/material';

import { SubHeading } from 'src/components';
import { MainCardWithHeader } from 'src/components/MainCardWithHeader';
import { useAddMerchantContext } from 'src/contexts/AddMerchantProvider';
import useCountryHelpers from 'src/hooks/useCountryHelpers';
import AddressDisplay from 'src/pages/AddMerchantPage/steps/SummaryInformation/components/InformationSection/components/AddressDisplay';
import { CountryDisplay } from 'src/pages/AddMerchantPage/steps/SummaryInformation/components/InformationSection/components/CountryDisplay';
import { TextDisplay } from 'src/pages/AddMerchantPage/steps/SummaryInformation/components/InformationSection/components/TextDisplay';

const AddServiceOutletInformation: FC = () => {
    const { merchantApplication, selectedOutlet, isExistingOutlet } = useAddMerchantContext();
    const { getPostalLabel } = useCountryHelpers();
    const postalLabel = getPostalLabel(merchantApplication?.partner?.countryDetails?.alpha2Code);

    let outlet = merchantApplication?.merchantInformation?.outlets.find((outlet) => {
        return outlet.name === selectedOutlet;
    });

    let outletName = outlet?.name;

    if (!outlet && (merchantApplication?.merchantInformation?.outlets?.length ?? 0) <= 1) {
        outletName = merchantApplication?.tradingName;
        outlet = merchantApplication?.merchantInformation?.outlets[0];
    }

    return (
        <>
            {outlet ? (
                <MainCardWithHeader heading={'Outlet Information'}>
                    <Box display="flex" gap="24px" flexDirection="column">
                        <Box width="100%" display="flex" justifyContent="space-between">
                            <TextDisplay
                                label="Existing Outlet?"
                                value={isExistingOutlet ? 'Yes' : 'No'}
                            />
                            <TextDisplay label="Outlet Name" value={outletName} />
                        </Box>
                        <SubHeading subHeading="Site Contact" />
                        <Box width="100%" display="flex" justifyContent="space-between">
                            <TextDisplay
                                label="First Name"
                                value={outlet?.siteContact?.firstName ?? ''}
                            />
                            <TextDisplay
                                label="Last Name"
                                value={outlet?.siteContact?.lastName ?? ''}
                            />
                        </Box>
                        <Box width="100%" display="flex" justifyContent="space-between">
                            <TextDisplay
                                label="Email Address"
                                value={outlet?.siteContact?.email ?? ''}
                            />
                            <CountryDisplay
                                label="Mobile Number"
                                value={outlet?.siteContact?.mobileNumber ?? ''}
                                country={outlet?.tradingAddress?.country}
                            />
                        </Box>
                        <Box width="100%" display="flex" justifyContent="space-between">
                            <CountryDisplay
                                label="Telephone Number"
                                value={outlet?.siteContact?.telephoneNumber ?? ''}
                                country={outlet?.tradingAddress?.country}
                            />
                            <TextDisplay
                                label="Position"
                                value={outlet?.siteContact?.position ?? ''}
                            />
                        </Box>
                        <AddressDisplay
                            heading="Trading Address"
                            postalLabel={postalLabel}
                            eirCode={outlet?.tradingAddress?.eircode}
                            addressLine1={outlet?.tradingAddress?.addressLine1}
                            addressLine2={outlet?.tradingAddress?.addressLine2}
                            city={outlet?.tradingAddress?.townOrCity}
                            country={outlet?.tradingAddress?.country}
                            county={outlet?.tradingAddress?.county}
                        />
                    </Box>
                </MainCardWithHeader>
            ) : null}
        </>
    );
};

export default AddServiceOutletInformation;
